import React, { useState } from "react";

export default function IFrameAI(props) {
    const [isShow, setIsShow] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);

    const handleClick = () => {
        window.open("https://knowledge.miwiz.net/platform/knowledge-bases/552a3a25-2077-461d-bca8-2c1f9f00ade1", "_blank");
        // setIsShow(!isShow);
        // props.setIsLeftNavbarHide(!isShow);
        // if (!isShow) {
        //     document
        //         .getElementsByClassName("left-custom-navbar")[0]
        //         .classList.add("hide-left-navbar");
        // } else {
        //     document
        //         .getElementsByClassName("left-custom-navbar")[0]
        //         .classList.remove("hide-left-navbar");
        // }
    }

    const handleClose = () => {
        setIsShow(false);
        setIsFullScreen(false);
        props.setIsLeftNavbarHide(false);
        document
            .getElementsByClassName("left-custom-navbar")[0]
            .classList.remove("hide-left-navbar");
    }
    return (
        <div className="iframe-ai">
            <div
                onClick={() => handleClick()}
                className="iframe-btn"
            >
                <span>Tra cứu với AI</span>
                <img src="/assets/img-ai.png" alt="img-ai" />
            </div>
            {/* <div className={`iframe-ai-content ${isShow ? "show" : ""} ${isFullScreen ? "fullscreen" : ""}`}>
                <div className="iframe-ai-header">
                    <span>AI Assistant</span>
                    <div>
                        <button className="fullscreen-btn" onClick={() => setIsFullScreen(!isFullScreen)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" /></svg>
                        </button>
                        <button className="close-btn" onClick={() => handleClose()}>&times;</button>
                    </div>
                </div>
                <iframe
                    src="https://knowledge.miwiz.net/platform/knowledge-bases/a2e9897c-44b1-4d78-87e8-67bcf08da01d"
                    title="Miwiz Knowledge Base"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                </iframe>
            </div> */}
        </div>
    );
}